/**
 * MM Friendship Day — locked gift → share link → personalized wheel (max 4)
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-mm-friendship]');
  if (!root) return;

  var stage = document.getElementById('mm-fs-stage');
  var pagePath = root.getAttribute('data-page-path') || '/pages/friendship';

  function detectLocale() {
    var saved = localStorage.getItem('mm_fs_locale');
    if (saved === 'ar' || saved === 'en') return saved;
    var path = (window.location.pathname || '').toLowerCase();
    if (/^\/ar(\/|$)/.test(path) || path.indexOf('/ar/') !== -1) return 'ar';
    var shopifyLoc = (window.Shopify && Shopify.locale) ? String(Shopify.locale).toLowerCase() : '';
    if (shopifyLoc.indexOf('ar') === 0) return 'ar';
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang.indexOf('ar') === 0) return 'ar';
    return 'en';
  }

  var locale = detectLocale();
  var dir = locale === 'ar' ? 'rtl' : 'ltr';
  root.setAttribute('dir', dir);

  var country =
    document.documentElement.getAttribute('data-mm-country') ||
    document.body.getAttribute('data-mm-country') ||
    'BH';

  var VISITOR_KEY = 'mm_fs_visitor';
  var UNLOCK_KEY = 'mm_fs_unlocked_code';
  var PROGRESS_KEY = 'mm_fs_progress';
  var DISMISS_KEY = 'mm_fs_resume_dismiss';

  function saveProgress(patch) {
    var prev = {};
    try {
      prev = JSON.parse(localStorage.getItem(PROGRESS_KEY) || '{}') || {};
    } catch (e) {
      prev = {};
    }
    var next = Object.assign({}, prev, patch, {
      pagePath: patch.pagePath || prev.pagePath || pagePath,
      updatedAt: Date.now(),
      done: !!patch.done,
    });
    if (patch.done) {
      localStorage.removeItem(PROGRESS_KEY);
      localStorage.removeItem(DISMISS_KEY);
      return;
    }
    localStorage.setItem(PROGRESS_KEY, JSON.stringify(next));
    if (next.code) localStorage.removeItem(DISMISS_KEY);
  }

  function clearProgress() {
    localStorage.removeItem(PROGRESS_KEY);
    localStorage.removeItem(DISMISS_KEY);
  }

  var FALLBACK_EN = {
    pageHeadline: 'Friendship Day',
    pageSubtitle: 'Send a short note. Unlock the wheel. Share the fun.',
    lockedTitle: 'Gift a friend to unlock',
    lockedSubtitle: 'Write a short message, share the link, then spin for your discount.',
    nameLabel: "Friend's name",
    messageLabel: 'Your message',
    yourNameLabel: 'Your name (optional)',
    createButton: 'Create gift link',
    shareTitle: 'Your link is ready',
    shareHint: 'Send it to your friend, then spin your wheel.',
    copyButton: 'Copy link',
    copied: 'Copied!',
    whatsappButton: 'Send on WhatsApp',
    spinTitle: 'Your friendship wheel',
    spinSubtitle: 'Everyone gets different prizes — this one is yours.',
    spinButton: 'Spin',
    spinning: 'Spinning…',
    preparingSpin: 'Preparing your spin…',
    creating: 'Creating…',
    winTitle: 'You won!',
    loseTitle: 'Almost!',
    loseHint: 'No worries — better luck next time.',
    productsTitle: 'Pick products for this discount',
    addButton: 'Add {count} to cart',
    giftBackTitle: 'Gift them back?',
    giftBackSubtitle: 'Send your friend a surprise message too.',
    giftBackButton: 'Gift back',
    unlockChip: 'Gift unlocks the wheel',
    uniqueChip: 'Your unique prizes',
    recipientCue: "Now it's your turn — spin the wheel",
    homeLink: 'Store',
    inactiveTitle: 'This drop has ended',
    inactiveSubtitle: 'Friendship Day is over for now. See you next time!',
    noPrizes: 'No prizes yet — check back soon.',
    tipHint: 'Keep it short and friendly.',
    namePlaceholder: 'e.g. Alex',
    messagePlaceholder: 'Write something nice…',
    yourNamePlaceholder: "So they know it's you",
    adding: 'Adding…',
    added: 'Added!',
    errorTry: 'Error — try again',
  };

  var FALLBACK_AR = {
    pageHeadline: 'يوم الصداقة',
    pageSubtitle: 'أرسل رسالة قصيرة، افتح العجلة، وشارك المفاجأة.',
    lockedTitle: 'أهدِ صديقك لفتح القفل',
    lockedSubtitle: 'اكتب رسالة قصيرة، أرسل الرابط، ثم لف العجلة على خصمك.',
    nameLabel: 'اسم الصديق',
    messageLabel: 'رسالتك',
    yourNameLabel: 'اسمك (اختياري)',
    createButton: 'إنشاء رابط الهدية',
    shareTitle: 'رابطك جاهز',
    shareHint: 'أرسله لصديقك، ثم لف عجلتك.',
    copyButton: 'نسخ الرابط',
    copied: 'تم النسخ',
    whatsappButton: 'إرسال عبر واتساب',
    spinTitle: 'عجلة الصداقة',
    spinSubtitle: 'كل شخص يحصل على خيارات مختلفة — هذه لك.',
    spinButton: 'لف العجلة',
    spinning: 'تدور…',
    preparingSpin: 'جاري تجهيز اللفة…',
    creating: 'جاري الإنشاء…',
    winTitle: 'مبروك!',
    loseTitle: 'للأسف',
    loseHint: 'لا بأس — حظ أوفر في مرة أخرى.',
    productsTitle: 'اختر منتجات لهذا الخصم',
    addButton: 'أضف {count} للسلة',
    giftBackTitle: 'ترسل هدية بالمقابل؟',
    giftBackSubtitle: 'فاجئ صديقك برسالة منك أيضاً.',
    giftBackButton: 'أرسل هدية مقابل',
    unlockChip: 'الهدية تفتح العجلة',
    uniqueChip: 'خياراتك الخاصة',
    recipientCue: 'دورك الآن — لف العجلة',
    homeLink: 'المتجر',
    inactiveTitle: 'انتهت الحملة',
    inactiveSubtitle: 'عرض يوم الصداقة انتهى حالياً. نراك لاحقاً!',
    noPrizes: 'لا توجد جوائز بعد — عد لاحقاً.',
    tipHint: 'اكتب رسالة قصيرة ولطيفة.',
    namePlaceholder: 'مثال: أحمد',
    messagePlaceholder: 'اكتب شيئاً جميلاً…',
    yourNamePlaceholder: 'حتى يعرف أنها منك',
    adding: 'جاري الإضافة…',
    added: 'تمت الإضافة!',
    errorTry: 'خطأ — أعد المحاولة',
  };

  function visitorKey() {
    var k = localStorage.getItem(VISITOR_KEY);
    if (!k) {
      k = 'v_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(VISITOR_KEY, k);
    }
    return k;
  }

  function apiUrl(params) {
    var q = new URLSearchParams(params || {});
    q.set('country', country);
    q.set('locale', locale);
    return '/apps/mm-app/api/friendship?' + q.toString();
  }

  function post(body) {
    return fetch('/apps/mm-app/api/friendship', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ country: country, visitorKey: visitorKey() }, body)),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok && !data.success) throw new Error(data.error || 'Request failed');
        return data;
      });
    });
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function setBtnLoading(btn, label) {
    if (!btn) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.classList.remove('is-pressed');
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML =
      '<span class="mm-fs__btn-spinner" aria-hidden="true"></span><span>' +
      esc(label) +
      '</span>';
  }

  function clearBtnLoading(btn, label) {
    if (!btn) return;
    btn.classList.remove('is-loading', 'is-pressed');
    btn.removeAttribute('aria-busy');
    btn.textContent = label;
  }

  function setWheelAwaiting(on) {
    var wrap = document.querySelector('.mm-fs__wheel-wrap');
    if (!wrap) return;
    wrap.classList.toggle('is-awaiting', !!on);
  }

  function qs(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  function shopifyLocaleCode(pref) {
    var cfg = window.MM_LOCALE_CONFIG || {};
    var roots = cfg.roots || {};
    var codes = Object.keys(roots);
    if (!codes.length) return null;
    var want = String(pref || '').toLowerCase();
    var i;
    for (i = 0; i < codes.length; i++) {
      var code = String(codes[i]).toLowerCase();
      if (code === want || code.indexOf(want + '-') === 0) return codes[i];
    }
    if (want === 'en') {
      for (i = 0; i < codes.length; i++) {
        if (String(codes[i]).toLowerCase().indexOf('en') === 0) return codes[i];
      }
    }
    return null;
  }

  function currentShopifyLocaleBucket() {
    var cfg = window.MM_LOCALE_CONFIG || {};
    var cur = String(cfg.current || document.documentElement.lang || '').toLowerCase();
    if (cur.indexOf('ar') === 0) return 'ar';
    if (cur.indexOf('en') === 0) return 'en';
    var path = (window.location.pathname || '').toLowerCase();
    if (/^\/ar(\/|$)/.test(path)) return 'ar';
    return 'en';
  }

  function switchShopifyLocale(next) {
    var target = shopifyLocaleCode(next);
    if (!target) return false;
    if (currentShopifyLocaleBucket() === next) return false;
    var form = document.getElementById('mm-fs-localization-form');
    var input = document.getElementById('mm-fs-locale-input');
    if (!form || !input) return false;
    input.value = target;
    var ret = form.querySelector('[name="return_to"]');
    if (!ret) {
      ret = document.createElement('input');
      ret.type = 'hidden';
      ret.name = 'return_to';
      form.appendChild(ret);
    }
    ret.value = window.location.pathname + window.location.search + window.location.hash;
    form.submit();
    return true;
  }

  function storeRoot() {
    if (window.Shopify && Shopify.routes && typeof Shopify.routes.root === 'string') {
      var r = Shopify.routes.root;
      return r.slice(-1) === '/' ? r : r + '/';
    }
    var path = (window.location.pathname || '').toLowerCase();
    if (/^\/ar(\/|$)/.test(path)) return '/ar/';
    return '/';
  }

  function productLocaleRoot() {
    if (locale === 'ar') {
      var cfg = window.MM_LOCALE_CONFIG || {};
      var arCode = shopifyLocaleCode('ar');
      if (arCode && cfg.roots && cfg.roots[arCode]) {
        var arRoot = String(cfg.roots[arCode] || '/');
        return arRoot.slice(-1) === '/' ? arRoot : arRoot + '/';
      }
      if (/^\/ar(\/|$)/.test((window.location.pathname || '').toLowerCase())) return '/ar/';
      return '/ar/';
    }
    return storeRoot();
  }

  function formatFsMoney(amount) {
    var n = Number(amount);
    if (!isFinite(n)) n = 0;
    var cur =
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      document.documentElement.getAttribute('data-mm-currency') ||
      '';
    cur = String(cur || '').toUpperCase();
    var decimals = cur === 'BHD' || cur === 'KWD' || cur === 'OMR' ? 3 : 2;
    var num = n.toFixed(decimals);
    if (!cur) return num;
    return locale === 'ar' ? num + '\u00A0' + cur : cur + '\u00A0' + num;
  }

  function truncateText(str, max) {
    var s = String(str || '').trim();
    if (s.length <= max) return s;
    return s.slice(0, Math.max(0, max - 1)).trim() + '…';
  }

  function productDisplayParts(p) {
    var productTitle = String(p.productTitle || '').trim();
    var full = String(p.title || productTitle || '').trim();
    var variantTitle = '';

    if (productTitle && full.indexOf(productTitle) === 0 && full.length > productTitle.length) {
      variantTitle = full.slice(productTitle.length).replace(/^\s*[-–—:|]\s*/, '').trim();
    } else {
      var dash = full.lastIndexOf(' - ');
      if (dash > 0) {
        productTitle = full.slice(0, dash).trim();
        variantTitle = full.slice(dash + 3).trim();
      } else {
        productTitle = full;
      }
    }
    if (/^default\s*title$/i.test(variantTitle)) variantTitle = '';

    // Prefer short brand after "|" (e.g. BOLERO®) over long English description
    var shortName = productTitle;
    if (productTitle.indexOf('|') !== -1) {
      var bits = productTitle.split('|').map(function (x) {
        return x.trim();
      }).filter(Boolean);
      var brand = bits[bits.length - 1] || '';
      shortName = brand.length && brand.length <= 24 ? brand : truncateText(bits[0] || productTitle, 34);
    } else {
      shortName = truncateText(productTitle, 34);
    }

    // If variant has a flavor after "/", prefer showing that as the main chip
    var flavor = '';
    if (variantTitle && variantTitle.indexOf('/') !== -1) {
      var parts = variantTitle.split('/');
      flavor = (parts[parts.length - 1] || '').trim();
    }

    return {
      name: shortName || truncateText(full, 34),
      variant: variantTitle ? truncateText(variantTitle, 42) : '',
      flavor: flavor ? truncateText(flavor, 28) : '',
    };
  }

  function productCardHtml(p, result) {
    var parts = productDisplayParts(p);
    var price = parseFloat(p.price) || 0;
    var disc = result.isFreeGift ? 0 : price * (1 - (result.discount || 0) / 100);
    var pct = result.isFreeGift ? 100 : result.discount || 0;
    var primary = parts.flavor || parts.variant || parts.name;
    var secondary = parts.flavor || parts.variant ? parts.name : '';
    if (parts.flavor && parts.variant && parts.variant !== parts.flavor) {
      secondary = parts.name;
      // keep pack size if useful and short
      var pack = parts.variant.replace(/\s*\/\s*[^/]+$/, '').trim();
      if (pack && pack.length <= 22) secondary = parts.name + ' · ' + pack;
    }
    return (
      '<button type="button" class="mm-fs__product" data-vid="' +
      esc(p.variantId) +
      '"' +
      (p.handle ? ' data-handle="' + esc(p.handle) + '"' : '') +
      '>' +
      (p.image
        ? '<img src="' + esc(p.image) + '" alt="" loading="lazy"/>'
        : '<div class="mm-fs__product-ph" aria-hidden="true"></div>') +
      '<div class="mm-fs__product-meta">' +
      '<div class="mm-fs__p-title">' +
      esc(primary) +
      '</div>' +
      (secondary
        ? '<div class="mm-fs__p-sub">' + esc(truncateText(secondary, 40)) + '</div>'
        : '<div class="mm-fs__p-sub" hidden></div>') +
      '<div class="mm-fs__p-prices">' +
      (price > disc
        ? '<span class="mm-fs__p-was">' + esc(formatFsMoney(price)) + '</span>'
        : '') +
      '<span class="mm-fs__p-now">' +
      esc(formatFsMoney(disc)) +
      '</span>' +
      '</div></div>' +
      '<span class="mm-fs__badge">-' +
      pct +
      '%</span></button>'
    );
  }

  function applyProductLabels(card, name, variant) {
    if (!card) return;
    var parts = productDisplayParts({
      productTitle: name,
      title: variant && !/^default\s*title$/i.test(variant) ? name + ' - ' + variant : name,
    });
    var primary = parts.flavor || parts.variant || parts.name;
    var secondary = '';
    if (parts.flavor || parts.variant) {
      secondary = parts.name;
      if (parts.flavor && parts.variant && parts.variant !== parts.flavor) {
        var pack = parts.variant.replace(/\s*\/\s*[^/]+$/, '').trim();
        if (pack && pack.length <= 22) secondary = parts.name + ' · ' + pack;
      }
    }
    var titleEl = card.querySelector('.mm-fs__p-title');
    var subEl = card.querySelector('.mm-fs__p-sub');
    if (titleEl && primary) titleEl.textContent = primary;
    if (subEl) {
      if (secondary) {
        subEl.textContent = truncateText(secondary, 40);
        subEl.hidden = false;
      } else {
        subEl.textContent = '';
        subEl.hidden = true;
      }
    }
  }

  function enrichArabicProductTitles(products) {
    if (locale !== 'ar' || !products || !products.length) return;
    var root = productLocaleRoot();
    var cache = {};

    function loadProduct(handle) {
      if (!handle) return Promise.resolve(null);
      if (cache[handle]) return cache[handle];
      // Liquid view returns Translate & Adapt titles; product.js often stays English
      var url = root + 'products/' + encodeURIComponent(handle) + '?view=mm-fs-json';
      cache[handle] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('product');
          return r.text();
        })
        .then(function (text) {
          var clean = String(text || '')
            .replace(/^\uFEFF/, '')
            .trim();
          // Some themes wrap JSON in HTML comments / whitespace
          var start = clean.indexOf('{');
          var end = clean.lastIndexOf('}');
          if (start === -1 || end === -1) throw new Error('json');
          return JSON.parse(clean.slice(start, end + 1));
        })
        .catch(function () {
          return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
            credentials: 'same-origin',
          })
            .then(function (r) {
              if (!r.ok) throw new Error('js');
              return r.json();
            })
            .catch(function () {
              return null;
            });
        });
      return cache[handle];
    }

    products.forEach(function (p) {
      var handle = p.handle;
      var vid = String(p.variantId || '');
      if (!vid) return;
      var card = null;
      document.querySelectorAll('.mm-fs__product[data-vid]').forEach(function (el) {
        if (el.getAttribute('data-vid') === vid) card = el;
      });
      if (!card) return;

      var run = handle
        ? loadProduct(handle)
        : Promise.resolve(null);

      // If handle missing, resolve via variant URL redirect
      if (!handle) {
        run = fetch('/variants/' + encodeURIComponent(vid), {
          credentials: 'same-origin',
          redirect: 'follow',
        })
          .then(function (r) {
            var path = (r.url || '').split('?')[0];
            var m = path.match(/\/products\/([^/?#]+)/i);
            if (!m) return null;
            handle = decodeURIComponent(m[1]);
            card.setAttribute('data-handle', handle);
            return loadProduct(handle);
          })
          .catch(function () {
            return null;
          });
      }

      run.then(function (prod) {
        if (!prod) return;
        var name = prod.title || '';
        var variant = '';
        var variants = prod.variants || [];
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === vid) {
            var vt = variants[i].title || '';
            if (vt && !/^default\s*title$/i.test(vt)) variant = vt;
            break;
          }
        }
        applyProductLabels(card, name, variant);
      });
    });
  }

  function shareUrl(code) {
    return window.location.origin + pagePath + '?g=' + encodeURIComponent(code);
  }

  // ---------- Wheel drawing (adapted from simple-wheel) ----------
  var WHEEL_CX = 150;
  var WHEEL_CY = 150;

  function shade(hex, pct) {
    var h = String(hex || '#e85d4c').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var r = parseInt(h.slice(0, 2), 16) || 232;
    var g = parseInt(h.slice(2, 4), 16) || 93;
    var b = parseInt(h.slice(4, 6), 16) || 76;
    var t = pct < 0 ? 0 : 255;
    var p = Math.abs(pct);
    return (
      'rgb(' +
      Math.round((t - r) * p + r) +
      ',' +
      Math.round((t - g) * p + g) +
      ',' +
      Math.round((t - b) * p + b) +
      ')'
    );
  }

  function drawWheel(svg, segments, rotation) {
    if (!svg || !segments || !segments.length) return;
    var n = segments.length;
    var angle = 360 / n;
    var angleOffset = -angle / 2;
    var r = 132;
    var parts = ['<defs>'];
    for (var d = 0; d < n; d++) {
      var base = segments[d].color || '#e85d4c';
      parts.push(
        '<linearGradient id="mm-fs-g-' +
          d +
          '" x1="0%" y1="0%" x2="100%" y2="100%">' +
          '<stop offset="0%" stop-color="' +
          shade(base, 0.22) +
          '"/>' +
          '<stop offset="100%" stop-color="' +
          shade(base, -0.18) +
          '"/>' +
          '</linearGradient>'
      );
    }
    parts.push('</defs>');
    parts.push(
      '<g id="mm-fs-disk" transform="rotate(' +
        (rotation || 0) +
        ' ' +
        WHEEL_CX +
        ' ' +
        WHEEL_CY +
        ')">'
    );
    parts.push(
      '<circle cx="' +
        WHEEL_CX +
        '" cy="' +
        WHEEL_CY +
        '" r="146" fill="none" stroke="#fff" stroke-width="6"/>'
    );
    for (var i = 0; i < n; i++) {
      var sA = i * angle - 90 + angleOffset;
      var eA = sA + angle;
      var sR = (sA * Math.PI) / 180;
      var eR = (eA * Math.PI) / 180;
      var x1 = WHEEL_CX + r * Math.cos(sR);
      var y1 = WHEEL_CY + r * Math.sin(sR);
      var x2 = WHEEL_CX + r * Math.cos(eR);
      var y2 = WHEEL_CY + r * Math.sin(eR);
      var la = angle > 180 ? 1 : 0;
      parts.push(
        '<path d="M' +
          WHEEL_CX +
          ',' +
          WHEEL_CY +
          ' L' +
          x1.toFixed(2) +
          ',' +
          y1.toFixed(2) +
          ' A' +
          r +
          ',' +
          r +
          ' 0 ' +
          la +
          ',1 ' +
          x2.toFixed(2) +
          ',' +
          y2.toFixed(2) +
          ' Z" fill="url(#mm-fs-g-' +
          i +
          ')" stroke="rgba(255,255,255,0.35)" stroke-width="1.5"/>'
      );
      var mid = ((sA + eA) / 2) * Math.PI / 180;
      var lx = WHEEL_CX + r * 0.62 * Math.cos(mid);
      var ly = WHEEL_CY + r * 0.62 * Math.sin(mid);
      var rot = (sA + eA) / 2 + 90;
      var label = locale === 'ar' && segments[i].labelAr ? segments[i].labelAr : segments[i].label;
      parts.push(
        '<text x="' +
          lx.toFixed(2) +
          '" y="' +
          ly.toFixed(2) +
          '" fill="#fff" font-size="14" font-weight="800" text-anchor="middle" dominant-baseline="middle" transform="rotate(' +
          rot.toFixed(2) +
          ',' +
          lx.toFixed(2) +
          ',' +
          ly.toFixed(2) +
          ')" style="paint-order:stroke;stroke:rgba(0,0,0,0.3);stroke-width:2px">' +
          esc(label) +
          '</text>'
      );
    }
    parts.push(
      '<circle cx="' +
        WHEEL_CX +
        '" cy="' +
        WHEEL_CY +
        '" r="26" fill="#fff"/><circle cx="' +
        WHEEL_CX +
        '" cy="' +
        WHEEL_CY +
        '" r="12" fill="#1a1f24"/><circle cx="' +
        WHEEL_CX +
        '" cy="' +
        WHEEL_CY +
        '" r="5" fill="#e85d4c"/>'
    );
    parts.push('</g>');
    svg.innerHTML = parts.join('');
  }

  function animateSpin(svg, segments, winIdx, done) {
    var n = segments.length;
    var angle = 360 / n;
    // Pointer at top: segment center should land under pointer
    var targetCenter = winIdx * angle;
    var finalRot = 360 * 5 + (360 - targetCenter);
    var disk = svg.querySelector('#mm-fs-disk');
    if (!disk) {
      done();
      return;
    }
    var start = null;
    var dur = 4200;
    var from = 0;
    function frame(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var ease = 1 - Math.pow(1 - t, 3);
      var deg = from + (finalRot - from) * ease;
      disk.setAttribute('transform', 'rotate(' + deg + ' ' + WHEEL_CX + ' ' + WHEEL_CY + ')');
      if (t < 1) requestAnimationFrame(frame);
      else done();
    }
    requestAnimationFrame(frame);
  }

  // ---------- State machine ----------
  var state = {
    config: null,
    textsEn: {},
    textsAr: {},
    giftCode: null,
    role: 'sender',
    gift: null,
    messagePreview: null,
    selected: [],
    result: null,
    spinning: false,
    parentForReply: null,
    screen: 'loading',
    screenOpts: null,
  };

  function t(key) {
    var pack = locale === 'ar' ? state.textsAr : state.textsEn;
    var fallback = locale === 'ar' ? FALLBACK_AR : FALLBACK_EN;
    if (pack && pack[key]) return pack[key];
    return fallback[key] || key;
  }

  function applyLocaleChrome() {
    dir = locale === 'ar' ? 'rtl' : 'ltr';
    root.setAttribute('dir', dir);
    var html = document.documentElement;
    html.setAttribute('lang', locale === 'ar' ? 'ar' : 'en');
    html.setAttribute('dir', dir);
    html.classList.toggle('rtl', locale === 'ar');
    if (document.body) {
      document.body.style.fontFamily =
        locale === 'ar' ? "'Cairo', system-ui, sans-serif" : "'Nunito', system-ui, sans-serif";
    }
    document.querySelectorAll('[data-mm-fs-lang]').forEach(function (btn) {
      var active = btn.getAttribute('data-mm-fs-lang') === locale;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    var homeLabel = document.querySelector('[data-mm-fs-home-label]');
    var home = document.querySelector('.mm-fs__home');
    if (homeLabel) homeLabel.textContent = t('homeLink');
    if (home) {
      var arrow = home.querySelector('span[aria-hidden]');
      if (arrow) arrow.textContent = locale === 'ar' ? '→' : '←';
    }
    var headline = document.querySelector('.mm-fs__headline');
    var lede = document.querySelector('.mm-fs__lede');
    if (headline) headline.textContent = t('pageHeadline');
    if (lede) lede.textContent = t('pageSubtitle');
  }

  function setLocale(next) {
    if (next !== 'ar' && next !== 'en') return;
    if (next === locale) return;
    locale = next;
    localStorage.setItem('mm_fs_locale', locale);
    applyLocaleChrome();
    if (switchShopifyLocale(locale)) return;
    rerenderCurrentScreen();
  }

  function bindLangSwitcher() {
    document.querySelectorAll('[data-mm-fs-lang]').forEach(function (btn) {
      if (btn._mmLangBound) return;
      btn._mmLangBound = true;
      btn.addEventListener('click', function () {
        setLocale(btn.getAttribute('data-mm-fs-lang'));
      });
    });
  }

  function rerenderCurrentScreen() {
    var s = state.screen;
    var opts = state.screenOpts || {};
    if (s === 'locked') renderLockedForm(opts);
    else if (s === 'share') renderShareThenWheel(opts.path || shareUrl(state.giftCode));
    else if (s === 'recipient') renderRecipientIntro();
    else if (s === 'wheel') renderWheel();
    else if (s === 'result') renderResult();
    else if (s === 'inactive') renderInactive();
  }

  function bindPress(scope) {
    (scope || stage).querySelectorAll('.mm-fs__btn, .mm-fs__product').forEach(function (el) {
      if (el._mmPressBound) return;
      el._mmPressBound = true;
      el.addEventListener('pointerdown', function () { el.classList.add('is-pressed'); });
      el.addEventListener('pointerup', function () { el.classList.remove('is-pressed'); });
      el.addEventListener('pointerleave', function () { el.classList.remove('is-pressed'); });
      el.addEventListener('pointercancel', function () { el.classList.remove('is-pressed'); });
    });
  }

  function setStage(html) {
    stage.innerHTML = html;
    bindPress(stage);
  }

  function applyVisualConfig(cfg) {
    if (cfg.pagePath) pagePath = cfg.pagePath;
    applyLocaleChrome();

    if (cfg.backgroundUrl) {
      root.style.setProperty('--mm-fs-bg-image', 'url(' + cfg.backgroundUrl + ')');
    }

    if (cfg.heroImageUrl) {
      var heroWrap = document.querySelector('.mm-fs__hero-pic') || document.querySelector('.mm-fs__hero-emoji');
      if (heroWrap && !heroWrap.querySelector('img[data-mm-fs-admin-hero]')) {
        var pic = document.createElement('div');
        pic.className = 'mm-fs__hero-pic';
        pic.innerHTML = '<img class="mm-fs__hero-img" data-mm-fs-admin-hero src="' + esc(cfg.heroImageUrl) + '" alt="" />';
        heroWrap.replaceWith(pic);
      }
    }

    function ensureDeco(side, url) {
      if (!url) return;
      var sel = side === 'left' ? '.mm-fs__deco--left' : '.mm-fs__deco--right';
      var el = document.querySelector(sel);
      if (!el) {
        el = document.createElement('div');
        el.className = 'mm-fs__deco mm-fs__deco--' + side;
        el.setAttribute('aria-hidden', 'true');
        root.appendChild(el);
      }
      el.innerHTML = '<img src="' + esc(url) + '" alt="" loading="lazy" />';
    }
    ensureDeco('left', cfg.decoImage1Url);
    ensureDeco('right', cfg.decoImage2Url);
  }

  function stepsHtml(active) {
    return (
      '<div class="mm-fs__steps" aria-hidden="true">' +
      [0, 1, 2].map(function (i) {
        return '<span class="mm-fs__step' + (i === active ? ' is-on' : '') + '"></span>';
      }).join('') +
      '</div>'
    );
  }

  function renderInactive() {
    state.screen = 'inactive';
    state.screenOpts = null;
    setStage(
      '<div class="mm-fs__panel" style="text-align:center">' +
        '<div class="mm-fs__lock-icon" style="margin:0 auto 0.75rem">🌙</div>' +
        '<h2 class="mm-fs__title">' + esc(t('inactiveTitle')) + '</h2>' +
        '<p class="mm-fs__muted">' + esc(t('inactiveSubtitle')) + '</p></div>'
    );
  }

  function renderLockedForm(opts) {
    opts = opts || {};
    var isReply = !!opts.isReply;
    state.screen = 'locked';
    state.screenOpts = opts;
    setStage(
      '<div class="mm-fs__panel">' +
        stepsHtml(0) +
        (isReply
          ? '<div class="mm-fs__lock">' +
            '<span class="mm-fs__chip">🔁 ' + esc(t('giftBackTitle')) + '</span>' +
            '<h2 class="mm-fs__title">' + esc(t('giftBackTitle')) + '</h2>' +
            '<p class="mm-fs__muted">' + esc(t('giftBackSubtitle')) + '</p></div>'
          : '<div class="mm-fs__lock">' +
            '<div class="mm-fs__lock-icon" aria-hidden="true">🔐</div>' +
            '<span class="mm-fs__chip">🎁 ' + esc(t('unlockChip')) + '</span>' +
            '<h2 class="mm-fs__title">' + esc(t('lockedTitle')) + '</h2>' +
            '<p class="mm-fs__muted">' + esc(t('lockedSubtitle')) + '</p></div>') +
        '<form id="mm-fs-create-form" class="mm-fs__form">' +
        '<div class="mm-fs__field"><label for="mm-fs-name">' + esc(t('nameLabel')) +
        '</label><input id="mm-fs-name" name="recipientName" required maxlength="80" autocomplete="name" placeholder="' + esc(t('namePlaceholder')) + '"/></div>' +
        '<div class="mm-fs__field"><label for="mm-fs-sender">' + esc(t('yourNameLabel')) +
        '</label><input id="mm-fs-sender" name="senderName" maxlength="80" placeholder="' + esc(t('yourNamePlaceholder')) + '"/></div>' +
        '<div class="mm-fs__field"><label for="mm-fs-msg">' + esc(t('messageLabel')) +
        '</label><textarea id="mm-fs-msg" name="message" required maxlength="500" placeholder="' + esc(t('messagePlaceholder')) + '"></textarea></div>' +
        '<p class="mm-fs__hint">' + esc(t('tipHint')) + '</p>' +
        '<button class="mm-fs__btn" type="submit">' +
        esc(isReply ? t('giftBackButton') : t('createButton')) +
        '</button>' +
        '<p class="mm-fs__error" id="mm-fs-err" hidden></p>' +
        '</form></div>'
    );

    document.getElementById('mm-fs-create-form').onsubmit = function (e) {
      e.preventDefault();
      var fd = new FormData(e.target);
      var btn = e.target.querySelector('button[type=submit]');
      var err = document.getElementById('mm-fs-err');
      btn.disabled = true;
      btn.classList.add('is-pressed');
      err.hidden = true;
      setBtnLoading(btn, t('creating'));
      post({
        action: 'create',
        recipientName: fd.get('recipientName'),
        senderName: fd.get('senderName'),
        message: fd.get('message'),
        parentGiftId: opts.parentGiftId || null,
      })
        .then(function (data) {
          if (!data.success) throw new Error(data.error || 'Failed');
          localStorage.setItem(UNLOCK_KEY, data.code);
          state.giftCode = data.code;
          state.role = 'sender';
          state.gift = data.gift;
          saveProgress({
            code: data.code,
            role: 'sender',
            step: 'share',
            pagePath: pagePath,
            done: false,
          });
          renderShareThenWheel(data.sharePath || pagePath + '?g=' + data.code);
        })
        .catch(function (ex) {
          err.textContent = ex.message || 'Error';
          err.hidden = false;
          clearBtnLoading(btn, isReply ? t('giftBackButton') : t('createButton'));
          btn.disabled = false;
        });
    };
  }

  function renderShareThenWheel(path) {
    var url = path.indexOf('http') === 0 ? path : window.location.origin + path;
    state.screen = 'share';
    state.screenOpts = { path: path };
    var waText = encodeURIComponent(
      (locale === 'ar'
        ? 'هدية يوم الصداقة لك: '
        : 'A Friendship Day gift for you: ') + url
    );
    setStage(
      '<div class="mm-fs__panel" style="text-align:center">' +
        stepsHtml(1) +
        '<div class="mm-fs__lock-icon" style="margin:0 auto 0.75rem" aria-hidden="true">🔗</div>' +
        '<h2 class="mm-fs__title">' + esc(t('shareTitle')) + '</h2>' +
        '<p class="mm-fs__muted">' + esc(t('shareHint')) + '</p>' +
        '<div class="mm-fs__share-box" id="mm-fs-share-url">' + esc(url) + '</div>' +
        '<button type="button" class="mm-fs__btn" id="mm-fs-copy">' + esc(t('copyButton')) + '</button>' +
        '<a class="mm-fs__btn mm-fs__btn--soft" id="mm-fs-wa" href="https://wa.me/?text=' + waText + '" target="_blank" rel="noopener">' +
        esc(t('whatsappButton')) + '</a>' +
        '<button type="button" class="mm-fs__btn mm-fs__btn--teal" id="mm-fs-go-spin" style="margin-top:0.6rem">' +
        esc(t('spinButton')) + '</button></div>'
    );
    document.getElementById('mm-fs-copy').onclick = function () {
      var btn = this;
      navigator.clipboard.writeText(url).then(function () {
        btn.textContent = t('copied');
      });
    };
    document.getElementById('mm-fs-go-spin').onclick = function () {
      renderWheel();
    };
  }

  function renderRecipientIntro() {
    var m = state.messagePreview || {};
    state.screen = 'recipient';
    state.screenOpts = null;
    var fromLine = m.senderName
      ? (locale === 'ar' ? 'من ' + m.senderName : 'From ' + m.senderName)
      : (locale === 'ar' ? 'إلى ' + (m.recipientName || '') : 'For ' + (m.recipientName || ''));
    setStage(
      '<div class="mm-fs__panel">' +
        stepsHtml(0) +
        '<div class="mm-fs__msg-card">' +
        '<p class="mm-fs__muted">' + esc(fromLine) + '</p>' +
        '<blockquote>“' + esc(m.message || '') + '”</blockquote></div>' +
        '<p class="mm-fs__muted" style="text-align:center;margin-bottom:1rem">' + esc(t('recipientCue')) + '</p>' +
        '<button type="button" class="mm-fs__btn mm-fs__btn--teal" id="mm-fs-open-wheel">' +
        esc(t('spinButton')) + '</button></div>'
    );
    document.getElementById('mm-fs-open-wheel').onclick = function () {
      renderWheel();
    };
  }

  function renderWheel() {
    var gift = state.gift || {};
    var segments = gift.segments || [];
    state.screen = 'wheel';
    state.screenOpts = null;
    if (!segments.length) {
      setStage('<div class="mm-fs__panel"><p class="mm-fs__error">' + esc(t('noPrizes')) + '</p></div>');
      return;
    }

    if (gift.hasSpun && gift.result) {
      state.result = gift.result;
      if (gift.hasClaimed) {
        clearProgress();
        if (state.role === 'sender') localStorage.removeItem(UNLOCK_KEY);
      } else {
        var won = (gift.result.discount || 0) > 0 || gift.result.isFreeGift;
        var hasProducts = gift.result.products && gift.result.products.length;
        if (!won || !hasProducts) {
          clearProgress();
          if (state.role === 'sender') localStorage.removeItem(UNLOCK_KEY);
        } else {
          saveProgress({
            code: state.giftCode,
            role: state.role,
            step: 'result',
            done: false,
          });
        }
      }
      renderResult();
      return;
    }

    setStage(
      '<div class="mm-fs__panel" style="text-align:center">' +
        stepsHtml(2) +
        '<span class="mm-fs__chip">✨ ' + esc(t('uniqueChip')) + '</span>' +
        '<h2 class="mm-fs__title" style="margin-top:0.55rem">' + esc(t('spinTitle')) + '</h2>' +
        '<p class="mm-fs__muted">' + esc(t('spinSubtitle')) + '</p>' +
        '<div class="mm-fs__wheel-wrap">' +
        '<div class="mm-fs__pointer-pin" aria-hidden="true">' +
        '<svg class="mm-fs__pointer" viewBox="0 0 30 34" width="28" height="32">' +
        '<path class="mm-fs__pointer-outer" d="M15 34 L1 2 L29 2 Z"/>' +
        '<path class="mm-fs__pointer-inner" d="M15 28 L7 6 L23 6 Z"/>' +
        '</svg></div>' +
        '<div class="mm-fs__wheel-loading" id="mm-fs-wheel-loading" aria-hidden="true">' +
        '<div class="mm-fs__wheel-loading-ring"></div>' +
        '<p class="mm-fs__wheel-loading-text">' + esc(t('preparingSpin')) + '</p>' +
        '</div>' +
        '<svg class="mm-fs-wheel" id="mm-fs-svg" viewBox="0 0 300 300"></svg></div>' +
        '<button type="button" class="mm-fs__btn" id="mm-fs-spin">' + esc(t('spinButton')) + '</button>' +
        '<p class="mm-fs__error" id="mm-fs-err" hidden></p></div>'
    );

    var svg = document.getElementById('mm-fs-svg');
    drawWheel(svg, segments, 0);

    document.getElementById('mm-fs-spin').onclick = function () {
      if (state.spinning) return;
      state.spinning = true;
      var btn = this;
      var err = document.getElementById('mm-fs-err');
      if (err) {
        err.hidden = true;
        err.textContent = '';
      }
      setBtnLoading(btn, t('spinning'));
      setWheelAwaiting(true);

      post({ action: 'spin', code: state.giftCode, role: state.role })
        .then(function (data) {
          if (data.error === 'Already spun' && data.gift) {
            state.gift = data.gift;
            state.result = data.gift.result;
            state.spinning = false;
            setWheelAwaiting(false);
            renderResult();
            return;
          }
          if (!data.success || !data.result) throw new Error(data.error || 'Spin failed');
          state.result = data.result;
          state.gift = data.gift;
          saveProgress({
            code: state.giftCode,
            role: state.role,
            step: 'result',
            done: false,
          });
          setWheelAwaiting(false);
          setBtnLoading(btn, t('spinning'));
          animateSpin(svg, segments, data.result.segmentIndex, function () {
            state.spinning = false;
            // No products / lose → nothing left to resume
            var won = (data.result.discount || 0) > 0 || data.result.isFreeGift;
            var hasProducts = data.result.products && data.result.products.length;
            if (!won || !hasProducts) {
              clearProgress();
              if (state.role === 'sender') localStorage.removeItem(UNLOCK_KEY);
            }
            renderResult();
          });
        })
        .catch(function (ex) {
          state.spinning = false;
          setWheelAwaiting(false);
          clearBtnLoading(btn, t('spinButton'));
          btn.disabled = false;
          if (err) {
            err.textContent = ex.message;
            err.hidden = false;
          }
        });
    };
  }

  function renderResult() {
    var result = state.result || {};
    var won = (result.discount || 0) > 0 || result.isFreeGift;
    var products = result.products || [];
    state.selected = [];
    state.screen = 'result';
    state.screenOpts = null;

    var html =
      '<div class="mm-fs__panel">' +
      stepsHtml(2) +
      '<div class="mm-fs__result-hero">' +
      '<div style="font-size:2.4rem">' + (won ? '🎉' : '✨') + '</div>' +
      '<h2 class="mm-fs__title">' + esc(won ? t('winTitle') : t('loseTitle')) + '</h2>' +
      (won
        ? '<div class="big">' +
          esc((locale === 'ar' && result.labelAr) || result.label || result.discount + '%') +
          '</div>'
        : '<p class="mm-fs__muted">' + esc(t('loseHint')) + '</p>') +
      '</div>';

    if (won && products.length) {
      html +=
        '<p class="mm-fs__muted" style="text-align:center">' + esc(t('productsTitle')) +
        '</p><div class="mm-fs__products" id="mm-fs-products">';
      products.forEach(function (p) {
        html += productCardHtml(p, result);
      });
      html +=
        '</div><button type="button" class="mm-fs__btn" id="mm-fs-add" disabled>' +
        esc(t('addButton').replace('{count}', '0')) + '</button>';
    }

    if (state.role === 'recipient') {
      html +=
        '<button type="button" class="mm-fs__btn mm-fs__btn--ghost" id="mm-fs-giftback">' +
        esc(t('giftBackButton')) + '</button>';
    }

    html += '</div>';
    setStage(html);

    if (won && products.length) {
      enrichArabicProductTitles(products);
    }

    var grid = document.getElementById('mm-fs-products');
    var addBtn = document.getElementById('mm-fs-add');
    if (grid && addBtn) {
      grid.querySelectorAll('.mm-fs__product').forEach(function (card) {
        card.onclick = function () {
          var vid = card.getAttribute('data-vid');
          var i = state.selected.indexOf(vid);
          if (i >= 0) {
            state.selected.splice(i, 1);
            card.classList.remove('is-selected');
          } else {
            state.selected.push(vid);
            card.classList.add('is-selected');
          }
          addBtn.disabled = state.selected.length === 0;
          addBtn.textContent = t('addButton').replace('{count}', String(state.selected.length));
        };
      });
      addBtn.onclick = function () {
        addToCart();
      };
    }

    var gb = document.getElementById('mm-fs-giftback');
    if (gb) {
      gb.onclick = function () {
        renderLockedForm({
          isReply: true,
          parentGiftId: (state.gift && state.gift.id) || state.giftCode,
        });
      };
    }
  }

  function addToCart() {
    var result = state.result || {};
    var addBtn = document.getElementById('mm-fs-add');
    if (addBtn) {
      setBtnLoading(addBtn, t('adding'));
    }
    var maxQty = (state.config && state.config.maxDiscountedQtyPerProduct) || 1;

    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var existing = [];
        try {
          if (cart.attributes && cart.attributes._flash_deals_data) {
            existing = JSON.parse(cart.attributes._flash_deals_data);
          }
        } catch (e) {}

        var items = state.selected.map(function (vid) {
          return { id: parseInt(vid, 10), quantity: 1 };
        });
        var deals = state.selected.map(function (vid) {
          return {
            variantId: vid,
            discountPercent: result.isFreeGift ? 100 : result.discount || 0,
            type: 'wheel',
            quantity: maxQty,
            isFreeGift: !!result.isFreeGift,
            minOrderAmount: result.minOrderAmount || 0,
            countryCode: country,
            isAlreadyDiscounted: false,
          };
        });
        var merged = existing.filter(function (d) {
          return !(d && d.type === 'wheel' && state.selected.indexOf(String(d.variantId).split('/').pop()) >= 0);
        }).concat(deals);

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        }).then(function () {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              attributes: { _flash_deals_data: JSON.stringify(merged) },
            }),
          });
        });
      })
      .then(function () {
        return post({ action: 'claim', code: state.giftCode, role: state.role });
      })
      .then(function () {
        clearProgress();
        if (state.role === 'sender') localStorage.removeItem(UNLOCK_KEY);
        if (window.MMCart && typeof window.MMCart.open === 'function') {
          window.MMCart.open();
        } else if (window.MMCart && typeof window.MMCart.refresh === 'function') {
          window.MMCart.refresh();
        }
        if (addBtn) {
          clearBtnLoading(addBtn, t('added'));
          addBtn.disabled = true;
          addBtn.style.background = '#10b981';
        }
        if (state.role === 'recipient') {
          setTimeout(function () {
            var panel = stage.querySelector('.mm-fs__panel');
            if (panel && !document.getElementById('mm-fs-giftback')) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'mm-fs__btn mm-fs__btn--ghost';
              b.id = 'mm-fs-giftback';
              b.textContent = t('giftBackButton');
              b.onclick = function () {
                renderLockedForm({
                  isReply: true,
                  parentGiftId: (state.gift && state.gift.id) || state.giftCode,
                });
              };
              panel.appendChild(b);
              bindPress(panel);
            }
          }, 400);
        }
      })
      .catch(function (e) {
        console.error('[MM Friendship]', e);
        if (addBtn) {
          clearBtnLoading(addBtn, t('errorTry'));
          addBtn.disabled = false;
        }
      });
  }

  // ---------- Boot ----------
  function boot() {
    bindLangSwitcher();
    applyLocaleChrome();
    // Sync Shopify storefront language with friendship preference (fonts, cart, RTL)
    if (localStorage.getItem('mm_fs_locale') && switchShopifyLocale(locale)) return;
    var giftParam = (qs('g') || '').trim().toUpperCase();

    fetch(apiUrl({ action: 'config' }))
      .then(function (r) {
        return r.json();
      })
      .then(function (cfg) {
        state.config = cfg;
        state.textsEn = cfg.textsEn || cfg.texts || {};
        state.textsAr = cfg.textsAr || {};
        applyVisualConfig(cfg);

        if (!cfg.active) {
          if (!giftParam) {
            renderInactive();
            return null;
          }
        }

        if (giftParam) {
          state.giftCode = giftParam;
          state.role = 'recipient';
          return post({ action: 'open', code: giftParam }).then(function (data) {
            if (data.error) throw new Error(data.error);
            state.gift = data.gift;
            state.messagePreview = data.messagePreview;
            if (data.gift && data.gift.hasClaimed) {
              clearProgress();
            } else if (data.gift && !data.gift.hasClaimed) {
              saveProgress({
                code: giftParam,
                role: 'recipient',
                step: data.gift.hasSpun ? 'result' : 'recipient',
                pagePath: pagePath,
                done: false,
              });
            }
            if (!cfg.active) {
              setStage(
                '<div class="mm-fs__panel"><div class="mm-fs__msg-card"><blockquote>“' +
                  esc((data.messagePreview && data.messagePreview.message) || '') +
                  '”</blockquote></div><p class="mm-fs__muted">' +
                  esc(t('inactiveSubtitle')) +
                  '</p></div>'
              );
              return;
            }
            renderRecipientIntro();
          });
        }

        var unlocked = localStorage.getItem(UNLOCK_KEY);
        if (unlocked) {
          state.giftCode = unlocked;
          state.role = 'sender';
          return fetch(apiUrl({ action: 'gift', code: unlocked, role: 'sender' }))
            .then(function (r) {
              return r.json();
            })
            .then(function (data) {
              if (data.gift) {
                state.gift = data.gift;
                if (data.gift.hasClaimed) {
                  clearProgress();
                  localStorage.removeItem(UNLOCK_KEY);
                } else {
                  saveProgress({
                    code: unlocked,
                    role: 'sender',
                    step: data.gift.hasSpun ? 'result' : 'share',
                    pagePath: pagePath,
                    done: false,
                  });
                }
                if (data.gift.hasSpun) {
                  state.result = data.gift.result;
                  renderResult();
                } else renderShareThenWheel(shareUrl(unlocked));
              } else {
                localStorage.removeItem(UNLOCK_KEY);
                clearProgress();
                renderLockedForm();
              }
            });
        }

        renderLockedForm();
        return null;
      })
      .catch(function (e) {
        console.error('[MM Friendship] boot', e);
        setStage(
          '<div class="mm-fs__panel"><p class="mm-fs__error">' +
            esc(e.message || 'Failed to load') +
            '</p></div>'
        );
      });
  }

  boot();
})();
